import { render, staticRenderFns } from "./auth-pay-button.vue?vue&type=template&id=d54a9884"
import script from "./auth-pay-button.vue?vue&type=script&lang=js"
export * from "./auth-pay-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports